import axios from 'axios'
import { BookingCount, BookingCountApiParams } from '../interface/party'
import { Location } from '../interface/location'

export const getBookingCounts = (
  locationId: Location['id'],
  query: BookingCountApiParams[]
): Promise<Array<BookingCount>> => {
  return axios.get('v2/bookings/counts', { params: { locationId, ranges: query } }).then((res) => res.data.data)
}